function generaMenu(asyncRouterList, data){
    if(!data) return
    data.forEach(item => {
        var menu = {
          path: item.path,
          component:item.pid == 1 ? () => import(`@/views/Home`) : () => import(`@/views${item.path}`),
          hidden: item.hidden,
          children: [],
          name: item.name,
          meta: { title: item.title, icon: item.icon, roles: ['common']}
        }
    //   }
      if (item.children) {
        generaMenu(menu.children, item.children)
      }
    //   console.log(menu)
      asyncRouterList.push(menu)
    })
}
export {
    generaMenu
}


// WEBPACK FOOTER //
// ./src/common/menujs.js